"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.closeAllModals = exports.CLOSE_ALL_MODALS = exports.toggleModal = exports.TOGGLE_MODAL = exports.closeModal = exports.CLOSE_MODAL = exports.openModal = exports.OPEN_MODAL = exports.getModalActions = void 0;

var typesafe_actions_1 = require("typesafe-actions");

var getModalActions = function getModalActions() {
  return {
    openModal: function openModal(name) {
      var metadata = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return typesafe_actions_1.action(exports.OPEN_MODAL, {
        name: name,
        metadata: metadata
      });
    },
    closeModal: function closeModal(name) {
      return typesafe_actions_1.action(exports.CLOSE_MODAL, {
        name: name
      });
    },
    toggleModal: function toggleModal(name) {
      return typesafe_actions_1.action(exports.TOGGLE_MODAL, {
        name: name
      });
    }
  };
};

exports.getModalActions = getModalActions;

var _exports$getModalActi = exports.getModalActions(),
    openModal = _exports$getModalActi.openModal,
    closeModal = _exports$getModalActi.closeModal,
    toggleModal = _exports$getModalActi.toggleModal;

exports.openModal = openModal;
exports.closeModal = closeModal;
exports.toggleModal = toggleModal; // Open Modal

exports.OPEN_MODAL = 'Open modal'; // Close Modal

exports.CLOSE_MODAL = 'Close modal'; // Toggle Modal

exports.TOGGLE_MODAL = 'Toggle modal'; // Close All Modals

exports.CLOSE_ALL_MODALS = 'Close all modals';

var closeAllModals = function closeAllModals() {
  return typesafe_actions_1.action(exports.CLOSE_ALL_MODALS, {});
};

exports.closeAllModals = closeAllModals;